module.exports = __webpack_public_path__ + "static/media/blue-gas-flames.df9f9898.png";